import { Text, mergeClasses } from "@fluentui/react-components";
import { useUiStyles, ArrowRightIcon, CalendarIcon, DocumentIcon, IconTile, RocketIcon, ShieldIcon, SparkleIcon, TeamsIcon, Footer } from "./ui";
import { useLanguage } from "../i18n/LanguageContext";

interface GuidePageProps {
  isAdmin: boolean;
}

const STEP_ICONS = [<SparkleIcon key="0" />, <TeamsIcon key="1" />, <CalendarIcon key="2" />, <DocumentIcon key="3" />, <ShieldIcon key="4" />, <RocketIcon key="5" />, <ShieldIcon key="6" />];

/** A permanent, skimmable guide to the complete Teams meeting-summary workflow. */
export function GuidePage({ isAdmin }: GuidePageProps) {
  const s = useUiStyles();
  const { t, tRaw } = useLanguage();
  const allSteps = tRaw<Array<{ title: string; body: string }>>("onboarding.steps");
  const steps = isAdmin ? allSteps : allSteps.slice(0, 6);

  return (
    <main className={s.page}>
      <div className={mergeClasses(s.hero, s.heroAccent)}>
        <IconTile variant="brand"><SparkleIcon /></IconTile>
        <div className={s.grow}>
          <Text size={500} weight="semibold" block>{t("guide.title")}</Text>
          <Text size={200} block style={{ marginTop: "4px", color: "var(--colorNeutralForeground2)" }}>
            {t("guide.subtitle")}
          </Text>
        </div>
      </div>

      <section className={s.section} aria-label={t("guide.title")}>
        <div className={mergeClasses(s.card, s.accentTop)} style={{ padding: "8px 18px" }}>
          {steps.map((step, index) => (
            <div key={step.title}>
              {index > 0 && <div className={s.divider} />}
              <div className={s.featureRow}>
                <div className={s.stepNum}>{index + 1}</div>
                <IconTile variant={index === 2 ? "success" : "brand"}>{STEP_ICONS[index]}</IconTile>
                <div className={s.grow}>
                  <Text size={300} weight="semibold" block>{step.title}</Text>
                  <Text size={200} block style={{ marginTop: "4px", color: "var(--colorNeutralForeground2)", lineHeight: 1.5 }}>
                    {step.body}
                  </Text>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className={mergeClasses(s.card, s.accentLeft)}>
        <div className={s.row}>
          <ArrowRightIcon />
          <Text size={200} block>{t("guide.tip")}</Text>
        </div>
      </div>

      <Footer>{t("homeFooter")}</Footer>
    </main>
  );
}